import { MemberCommitmentEventDetail } from '../../../components/Commitment/CommitmentEvents/MemberCommitmentEventDetail';

export function MemberCommitmentEvent() {
  return <MemberCommitmentEventDetail />;
}
